'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _reactRedux = require('react-redux');

var _AddPointsPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/library/AddPointsPopup');

var _AddPointsPopup2 = _interopRequireDefault(_AddPointsPopup);

var _payments = require('redux/modules/payments');

var _customer = require('redux/modules/customer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddPointsPopupContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    pointsMap: state.user.subscription.refillPricePointMap,
    customer: state.customer.customer
  };
}, { initPayment: _payments.initPayment, getPrice: _payments.getPrice, getCustomer: _customer.getCustomer }), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(AddPointsPopupContainer, _React$Component);

  function AddPointsPopupContainer(props) {
    (0, _classCallCheck3.default)(this, AddPointsPopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AddPointsPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(AddPointsPopupContainer)).call(this, props));

    _this.handleAddPointClick = _this.handleAddPointClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(AddPointsPopupContainer, [{
    key: 'handleAddPointClick',
    value: function handleAddPointClick(plan) {
      var _this2 = this;

      var customer = this.props.customer;
      // Close the popup on "Add Points" click
      // Redirection is done via link prop

      this.props.onCloseYes();

      // Initializing payment and pricing to avoid
      // 'sticky total price' issue on buy points checkout
      return _bluebird2.default.resolve(this.props.initPayment(plan)).then(function (res) {
        return _this2.props.getCustomer();
      }).then(function (customer) {
        var countryCode = customer.countryCode || 'US';
        _this2.props.getPrice((0, _extends3.default)({
          transactionType: 'refill-subscription',
          countryCode: countryCode,
          price: plan.price
        }, customer.vatNo && {
          vatNo: customer.vatNo
        }));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var pointsMap = this.props.pointsMap;


      return _react2.default.createElement(_AddPointsPopup2.default, {
        bgImage: '/images/app-points-bg.jpg',
        link: '/purchase',
        pointsMap: pointsMap,
        onAddPointsClick: this.handleAddPointClick
      });
    }
  }]);
  return AddPointsPopupContainer;
}(_react2.default.Component)) || _class);
exports.default = AddPointsPopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AddPointsPopup/AddPointsPopup.jsx
// module id = 2493
// module chunks = 0